import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import classnames from 'classnames';

const classes = ['fullWidth', 'flex', 'direction', 'alignItems', 'alignContent', 'justifyContent', 'wrap'];
const breakpoints = ['sm', 'md', 'lg', 'xl', 'xxl'];
const Container = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    className = '',
    ...rest
  } = _ref;
  const baseClass = 'b-container';
  const configurableClassNames = {};
  classes.forEach(classItem => {
    const classValue = rest?.[classItem];
    if (typeof classValue === 'string') {
      const capValue = classValue.charAt(0).toUpperCase() + classValue.slice(1);
      configurableClassNames[`${baseClass}--${classItem}${capValue}`] = true;
    } else if (classValue) {
      configurableClassNames[`${baseClass}--${classItem}`] = true;
    }
  });
  breakpoints.forEach(breakpoint => {
    const bp = rest[breakpoint];
    if (!rest?.fullWidth) {
      configurableClassNames[`${baseClass}--${breakpoint}`] = true;
    }
    if (bp) {
      classes.forEach(classItem => {
        const classValue = bp[classItem];
        if (typeof classValue === 'string') {
          const capValue = classValue.charAt(0).toUpperCase() + classValue.slice(1);
          configurableClassNames[`${baseClass}--${breakpoint}-${classItem}${capValue}`] = true;
        } else if (typeof rest?.[breakpoint]?.[classItem] === 'boolean') {
          configurableClassNames[`${baseClass}--${breakpoint}-${classItem}`] = true;
        }
      });
    }
  });
  const classNames = classnames(className, baseClass, configurableClassNames);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classNames,
    ref: ref,
    "data-testid": "container"
  }, rest), children);
});
Container.displayName = 'Container';

export { Container };
